// Vuex transaction module actions
import { API } from '@/config';
import { FILL_HEADERS, FILL_QUEUE, FILL_STATUS_AND_TYPE_DICTIONARY, FILL_HISTORY, FILL_TEMPLATES, FILL_INCOMING } from './mutations-types';

export default {

  async getSmsHeadersList({ commit }) {
    try {
      const { records } = (await API.get('/sms/getSmsHeadersList')).data.data;
      commit(FILL_HEADERS, records );
    } catch (err) {
      console.log(err);
    }
  },
  async getSmsTemplatesList({ commit }, projectUuid) {
    try {
      const params = {
        project_uuid: projectUuid,
      }
      const { records } = (await API.get('/sms/getSmsTemplatesList', { params })).data.data;
      commit(FILL_TEMPLATES, records);
    } catch (err) {
      console.log(err);
    }
  },
  async editSmsTemplate({ commit }, params) {
    try {
      const { data } = await API.patch('/sms/editSmsTemplate', params);
      return data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async createSmsTemplate({ commit }, params) {
    try {
      const { data } = await API.put('/sms/createSmsTemplate', params);
      return data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async removeSmsTemplate({ commit }, params) {
    try {
      const { data } = await API.patch('/sms/removeSmsTemplate', params);
      return data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async addSmsToQueue({ commit }, params) {
    try {
      const response = await API.put('/sms/addSmsToQueue', params );
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async addMultipleSmsToQueue({ commit }, params) {
    try {
      const response = await API.put('/sms/addMultipleSmsToQueue', params );
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSmsQueueList({ commit }) {
    try {
      const { records, total } = (await API.get('/sms/getSmsQueueList' )).data.data;
      commit(FILL_QUEUE, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  async getStatusAndTypeDictionary({ commit }) {
    try {
      const response = (await API.get('/sms/getStatusAndTypeDictionary' )).data.data;
      commit(FILL_STATUS_AND_TYPE_DICTIONARY, response);
    } catch (err) {
      console.log(err);
    }
  },
  async removeSmsFromQueue({ commit }, params) {
    try {
      const response = await API.patch('/sms/removeSmsFromQueue', params );
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async sendAllSmsFromProject(context, projectUuid) {
    try {
      const params = {
        project_uuid: projectUuid,
      }
      const response = await API.get('/sms/sendAllSmsFromProject', { params });
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSmsHistoryList({ commit }) {
    try {
      const { records, total } = (await API.get('/sms/getSmsHistoryList')).data.data;
      commit(FILL_HISTORY, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  async getIncomingSmsList({ commit }) {
    try {
      const { records, total } = (await API.get('/sms/getIncomingSmsList')).data.data;
      commit(FILL_INCOMING, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
  async getRefreshAllSmsStatus(context) {
    try {
      const response = await API.get('/sms/getRefreshAllSmsStatus');
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async updateNote(context, params) {
    try {
      const response = await API.patch('/sms/updateNote', params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async deleteSmsFromIncoming({ commit }, params) {
    try {
      const response = await API.patch('/sms/deleteSmsFromIncoming', params );
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
};
